import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from '../components/LeftSocialMediaIconUI';
import { BuildingLeftMenuList } from '../utils/constants';
import { RenderNavItem } from '../components/RenderNavItem';

const Building_Sanction_Floor_Area_Ratio  = () => {
 
  const { t, i18n, ready } = useTranslation();
  return (
    <>
  <section id="hero" className="hero hero2">
   <LeftSocialMediaIconUI />
    
    <div className="carousel-item active">
      <img src="assets/img/inner-bg2.png" className="img-fluid" alt="alt" />
    </div>
  </section>
  <section className="section inner-pad1">
    <div className="container">
      <div className="row">
        <div className="col-lg-3">
          <div className="site-menu  min-height-400">
          <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {BuildingLeftMenuList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
          </div>
        </div>
        <div className="col-lg-9">
          <div className="container">
            <div className="row">
              <div className="inner-title2 bas">
                <h3 className="fontSizeClass"> {t("Floor Area Ratios")}</h3>
              </div>
              <div className=" health-dept-table">
                <p className="para_building">
                  1.{t("Save as otherwise determined by the Mayor-in-Council, with regard to any specification made in this behalf under the West Bengal Town and Country (Planning and Development) Act, 1979, the Floor Area Ratios shall be as specified in Table 3 below")}:
                </p>
                <p className="fontSizeClass"></p>
                <table width="95%" border={0} align="center"
                  className="table table-bordered officials">
                  <tbody>
                    <tr>
                      <td align="center">
                        <b>{t("Table 3 Maximum Permissible Floor Area Ratio")}</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table width="100%" className="table mayor-table table-bordered officials">
                  <tbody>
                    <tr bgcolor="#302ba0" align="center">
                      <td width="4%" className="text-white" rowSpan={2}>
                        <div className="fontSizeClass">{t("Sl.No")}.</div>
                      </td>
                      <td width="27%" rowSpan={2} className="text-white">
                        <div className="fontSizeClass">{t("Width of means of access (Meters)")}</div>
                      </td>
                      <td colSpan={4}>
                        <div align="center" className="text-white">
                          {t("Use groups of buildings")}
                        </div>
                      </td>
                    </tr>
                    <tr bgcolor="#302ba0" align="center">
                      <td width="11%" className="text-white">
                        <div align="center">{t("Residential Buildings")}</div>
                      </td>
                      <td width="12%" className="text-white">
                        <div align="center">{t("Educational Buildings")} </div>
                      </td>
                      <td width="22%" className="text-white">
                        <div align="center">
                          {t("Industrial, Storage and Hazardous Buildings")}
                        </div>
                      </td>
                      <td width="24%" className="text-white">
                        <div align="center">
                          {t("Assembly, Institutional business, Merchantile (incl. mixed use) Buildings")}
                        </div>
                      </td>
                    </tr>
                    <tr align="center">
                      <td width="4%" align="center"> 1. </td>
                      <td>
                        <div align="center">{t("Below 2.4")}</div>
                      </td>
                      <td>{t("NIL")} </td>
                      <td>
                        <div className="fontSizeClass">{t("NIL")} </div>
                      </td>
                      <td>
                        <div className="fontSizeClass">{t("NIL")}</div>
                      </td>
                      <td>
                        <div className="fontSizeClass">{t("NIL")}</div>
                      </td>
                    </tr>
                    <tr align="center">
                      <td width="4%" align="center"> 2.</td>
                      <td>{t("Above 2.4 to 3.5")}</td>
                      <td>1.25</td>
                      <td>
                        <div className="fontSizeClass"> {t("NIL")} </div>
                      </td>
                      <td>
                        <div className="fontSizeClass">{t("NIL")}</div>
                      </td>
                      <td>
                        <div className="fontSizeClass"> {t("NIL")} </div>
                      </td>
                    </tr>
                    <tr align="center">
                      <td width="4%" align="center"> 3. </td>
                      <td>{t("Above 3.5 to 7.0")}</td>
                      <td>1.75</td>
                      <td>{t("NIL")}</td>
                      <td>{t("NIL")}</td>
                      <td> {t("NIL")}</td>
                    </tr>
                    <tr align="center">
                      <td align="center">4.</td>
                      <td> {t("Above 7.0 to 9.0")} </td>
                      <td>2.00</td>
                      <td> 2.00 </td>
                      <td> {t("NIL")} </td>
                      <td>{t("NIL")} </td>
                    </tr>
                    <tr align="center">
                      <td align="center">5.</td>
                      <td>{t("Above 9.0 to 15.0")}</td>
                      <td>2.25</td>
                      <td>2.25</td>
                      <td>2.00</td>
                      <td>2.00</td>
                    </tr>
                    <tr align="center">
                      <td align="center">6.</td>
                      <td>{t("Above 15.0 to 20.0")}</td>
                      <td>2.50</td>
                      <td>2.50</td>
                      <td>2.00</td>
                      <td>2.25</td>
                    </tr>
                    <tr align="center">
                      <td align="center">7.</td>
                      <td>{t("Above 20.0 to 24.0")}</td>
                      <td>2.75</td>
                      <td>2.75</td>
                      <td>2.00</td>
                      <td>2.50</td>
                    </tr>
                    <tr align="center">
                      <td align="center">8.</td>
                      <td>{t("Above 24.0")}</td>
                      <td>3.00</td>
                      <td>3.00 </td>
                      <td>2.00</td>
                      <td>2.75</td>
                    </tr>
                  </tbody>
                </table>
                <p className="para_building">
                  {t("Provided that the width of means of access mentioned under Table 3 is to be taken as the average road width abutting the entire length of the plot")}.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</>

  )
}

export default Building_Sanction_Floor_Area_Ratio